import { CommonModule } from '@angular/common';
import { Component, OnInit, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HeaderComponent as GbHeaderComponent } from '@bookinglab/govbook-ui/layout';
import {
  ImageDetail,
  NavLink,
} from '@bookinglab/govbook-ui/layout/lib/util/model';
@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	standalone: true,
	imports: [CommonModule, GbHeaderComponent, MatIconModule],
})
export class HeaderComponent {
	goToWebsite() {
		window.open('https://www.redbridge.gov.uk/', '_blank', 'noopener,noreferrer');
	}

	imageDetail: ImageDetail = {
		alt: 'Redbridge Council information on births, deaths and marriages',
		src: 'assets/redbridge_logo.png',
		href: 'https://www.redbridge.gov.uk/births-deaths-marriages-civil-partnerships-and-citizenship/',
	};

	navigation: NavLink[] = [
		{
			text: 'Sign in',
			url: 'https://my.redbridge.gov.uk/',
		},
	];

	search(term: string) {
		const formatted = term.trim().replace(/\s+/g, '+');
		const url = `www.redbridge.gov.uk/search/classic?keyword=${formatted}`;
		window.location.href = url;
	}
}
